import {Dispatch} from "@reduxjs/toolkit";
import {NfeService} from "../../../nfe/nfe.service";
import {FileUtil} from "../../util/file-util";
import {decodeUint8Array} from "../../util/string-util";
import {setAlert} from "../../redux/actions";

export const issueCardNfe = (saleId: number, dispatch: Dispatch, onClose: (success: boolean) => void) => {
    NfeService.geraNFeDeCartao(saleId).then((result) => {
        if (result.status === 204) {
            dispatch(setAlert({
                show: true,
                message: 'Venda fechada com sucesso. NF-e não emitida: integração desativada',
                severity: 'success'
            }));
        } else {
            dispatch(setAlert({show: true, message: 'Venda fechada com sucesso', severity: 'success'}));
            FileUtil.openPdfInNewTab(result);
        }
        onClose(true);
    }, (result) => {
        const error = decodeUint8Array(result);
        dispatch(setAlert({show: true, message: 'Erro ao gerar NFe - ' + error.message, severity: 'error'}));
        onClose(true);
    });
};
